import useSelectedCurrency from './useSelectedCurrency';

const getCurrencyOptions = (
  inGameCurrencyList: string[],
  selectedCurrency?: string,
) => {
  const isBlankOptionSelected =
    !selectedCurrency ||
    !inGameCurrencyList.some((currency) => currency === selectedCurrency);
  const baseOptions = inGameCurrencyList.map((currency) =>
    createOption(currency, currency, currency === selectedCurrency),
  );
  const blankOption = [createOption('default', null, isBlankOptionSelected)];
  const options = [...baseOptions, ...blankOption];

  return options;
};

const createOption = (
  name: string,
  value: string | null,
  selected?: boolean,
) => ({
  name,
  value,
  selected,
});

const useGameCurrencySelect = (
  isUbtcEnabled: boolean,
  inGameCurrencyList: string[],
  initialInGameCurrency?: Unit,
  cashierCurrency?: CashierCurrency,
) => {
  const { handleChange, selectedCurrency, isDisabled } = useSelectedCurrency(
    isUbtcEnabled,
    initialInGameCurrency,
    cashierCurrency,
  );
  const options = getCurrencyOptions(inGameCurrencyList, selectedCurrency);
  const isSelectedCurrencyInList = options.some(
    (option) => option.value === selectedCurrency,
  );

  return {
    isDisabled,
    options,
    selectedCurrency: isSelectedCurrencyInList ? selectedCurrency : undefined,
    handleChange,
  };
};

export default useGameCurrencySelect;
